// component/NavBar.js
import { useRef, useState, useEffect } from "react"
import { Link, NavLink, useNavigate } from "react-router-dom";
import Dropdown from 'react-bootstrap/Dropdown';
import { Nav, Navbar, NavDropdown } from 'react-bootstrap';

const NavBar = (props) => {

  const usenav = useNavigate();
  const [searchVal, setSearchval] = useState("")

  useEffect(() => {
    if (searchRef.current) {
      searchRef.current.focus();
    }
  }, []);

  const searchRef = useRef(null);
  var m1;
  var m2;
  var m3;
  var m4;
  if (props.vprofile === "user") {
    //m1 = <NavLink to="/pacientes">Pacientes</NavLink>
    //m2 = <NavLink to="/intervenciones">Intervenciones</NavLink>
    m1 = <Dropdown.Item to="/pacientes"> <NavLink to="/pacientes">Pacientes</NavLink></Dropdown.Item>
    m2 = ""
    m3 = <Dropdown.Item><NavLink to="/intervnueva">Nueva</NavLink></Dropdown.Item>
    m4 = <Dropdown.Item><NavLink to="/intervbuscar">Buscar</NavLink></Dropdown.Item>

  }
  else {
    // m1 = <NavLink to="/organos">Órganos</NavLink>
    // m2 = <NavLink to="/doctores">Doctores</NavLink>
    //m1 = <Dropdown.Item><NavLink to="/alumnos">Alumnos</NavLink></Dropdown.Item> 

    //m1b = "Alumnos"
    m1 = <Dropdown.Item><NavLink to="/Alumnos">Alumnos</NavLink></Dropdown.Item>
    m2 = <Dropdown.Item><NavLink to="/resultados">Resultados</NavLink></Dropdown.Item>
    m3 = <Dropdown.Item><NavLink to="/doctores">Doctores</NavLink></Dropdown.Item>
    m4 = <Dropdown.Item><NavLink to="/secciones">Secciones</NavLink></Dropdown.Item>
  }

  async function handleKeyDown(ev) {
    if (ev.key === 'Enter') {
      handleSearch();
    }


  }
  async function handleSearch() {
    console.log("en el handle");

    var jstring;
    var url;
    jstring = '{"search" : "' + searchVal + '", "favoritos" : 0, "grusu" : ' + props.vgrusu + '}';

    url = `${process.env.REACT_APP_API_URL}/alu/search`;

    /* fetch de búsqueda */
    var options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      mode: 'cors',
      credential: 'include',
      body: jstring,
      //JSON.stringify({"code" : 4, "activo" : true}),

    };

    fetch(url, options)
      .then(response => response.json())
      .then(data => {
        console.log("búsqueda", data);
        usenav('/resultados', { state: { searchdata: data.data } });
        /*  if ( data.lista.length)
          {

            
            setListSearch(data.lista);

          }          
            */
      })

    setSearchval("");


  }


  return (
    <>

      <header className="navegador">

        {/* IZQUIERDA */}
        <div className="nav-izq">
        </div>

        {/* CENTRO */}
        <div className="nav-centro">

          <input
            type="text"
            id="searchval"
            name="searchval"
            ref={searchRef}
            onKeyDown={handleKeyDown}
            onChange={e => setSearchval(e.target.value)}
            value={searchVal}
            placeholder="Buscar alumno..."
          />

          <button
            type="button"
            className="filtrar"
            id="searchtxt"
            onClick={handleSearch}
          >
            <i className="fa-solid fa-magnifying-glass me-2"></i>
            Buscar
          </button>

        </div>

        {/* DERECHA */}
        <div className="nav-der">

          {
            props.usrName !== "" &&

            <NavDropdown
              title={props.usrName}
              id="user-dropdown"
            >

              <NavDropdown.Item as={NavLink} to="/alumnos">
                Cambiar Contraseña
              </NavDropdown.Item>

              <NavDropdown.Item as={NavLink} to="/salir">
                Salir
              </NavDropdown.Item>

            </NavDropdown>
          }

        </div>

      </header>

    </>
  );
};

export default NavBar;